export default __webpack_public_path__ + "static/media/EP21_ERYTHREE.845afdcb.mp3";